import { render } from "./ActionsAttachmentHeaderNew.vue?vue&type=template&id=7daf6162&scoped=true"
import script from "./ActionsAttachmentHeaderNew.vue?vue&type=script&lang=js"
export * from "./ActionsAttachmentHeaderNew.vue?vue&type=script&lang=js"

import "./ActionsAttachmentHeaderNew.vue?vue&type=style&index=0&id=7daf6162&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7daf6162"]])

export default __exports__